import { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLongPress } from 'use-long-press';

import DimesionPage from 'pages/PlanPageDetailsOPZ/Inputs/DimensionPage';
import IndicatorPageMultiDim from 'pages/PlanPageDetailsOPZ/Inputs/IndicatorPageMultiDim';
import { getSelectedDriver, planPageShow } from 'redux/PlanPageSlice';

import { usePlanPageUiRevamp } from '../usePlanPageUiRevamp';
import { createInputPanelEditRefetch } from '../planPageFetchHelpers';

import RevampOrganisationPanel from './RevampOrganisationPanel';

import type { PlanPageRefetchRequest } from '../planPageFetchHelpers';

interface Properties {
  refetchRequest: PlanPageRefetchRequest;
}

/**
 * Revamp inputs shell — only organisation (org chart + table) uses new UI.
 * Indicator and property drivers keep legacy panels.
 */
const RevampInputSection = ({ refetchRequest }: Properties) => {
  const isRevampEnabled = usePlanPageUiRevamp();
  const [isLongClicked, setIsLongClicked] = useState(false);
  const currentDriver = useSelector(getSelectedDriver);
  const showPlanPage = useSelector(planPageShow);

  const longClickCheck = useLongPress(() => {
    setIsLongClicked((previousState) => !previousState);
  });

  const onInputEdit = createInputPanelEditRefetch(refetchRequest, showPlanPage, currentDriver);

  if (!isRevampEnabled) {
    return null;
  }

  if (currentDriver?.type === 'dimension') {
    return (
      <RevampOrganisationPanel
        longClickCheck={longClickCheck}
        isLongClicked={isLongClicked}
        refetchRequest={refetchRequest}
        onInputEdit={onInputEdit}
      />
    );
  }

  if (currentDriver?.type === 'indicator') {
    return <IndicatorPageMultiDim refetchRequest={refetchRequest} />;
  }

  return <DimesionPage refetchRequest={refetchRequest} onInputEdit={onInputEdit} />;
};

export default memo(RevampInputSection);
